import { jsx as m } from "react/jsx-runtime";
import { forwardRef as d, useEffect as x } from "react";
import { useValues as v, useTooltip as A } from "./chart-utils.js";
import { Tooltip as C } from "../../tooltip/tooltip.js";
import g from "clsx";
import M from "../chart.module.css.js";
const L = d(
  function({ className: n, children: o, ...t }, r) {
    const [s, c] = v(r), u = g(M.doughnut, n);
    return x(() => {
      if (!s.length)
        return;
      const i = D(s.map(({ value: e }) => e));
      s.forEach(({ el: e }, h) => e.setAttribute("d", i[h]));
    }, [s]), /* @__PURE__ */ m("div", { className: u, ref: c, ...t, children: /* @__PURE__ */ m("svg", { viewBox: "0 0 100 100", children: o }) });
  }
), N = d(function({ className: n, tooltip: o, value: t, ...r }, s) {
  return /* @__PURE__ */ m(
    C,
    {
      as: "path",
      className: g(M.doughnutSlice, n),
      "data-value": t,
      ref: s,
      ...A(o, t),
      ...r
    }
  );
});
function D(a) {
  const n = a.reduce((s, c) => s + c, 0), o = 25, t = 50;
  let r = 0;
  return a.map((s) => {
    const c = r / n, u = (r += s) / n, i = u - c > 0.5 ? 1 : 0, e = 2 * Math.PI * (c - 0.25), h = 2 * Math.PI * (u - 0.25), f = Math.cos(e), l = Math.sin(e), $ = Math.cos(h), p = Math.sin(h);
    return `
      M ${t + o * f} ${t + o * l} 
      L ${t + t * f} ${t + t * l} 
      A ${t} ${t} 0 ${i} 1 ${t + t * $} ${t + t * p}
      L ${t + o * $} ${t + o * p}
      A ${o} ${o} 0 ${i} 0 ${t + o * f} ${t + o * l}`;
  });
}
export {
  L as ChartDoughnut,
  N as ChartDoughnutSlice
};
//# sourceMappingURL=chart-doughnut.js.map
